module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.0-rc.49-200.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.1.0-rc.49.md
// module id = 643
// module chunks = 367